import { render, staticRenderFns } from "./inputSelect.vue?vue&type=template&id=539113f1"
import script from "./inputSelect.vue?vue&type=script&lang=ts"
export * from "./inputSelect.vue?vue&type=script&lang=ts"
import style0 from "./inputSelect.vue?vue&type=style&index=0&id=539113f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports